import { runEvalScript } from "..";
import { rootStore } from "../../store/root";
export type problemTypes =
  | "Wav"
  | "AudOffset"
  | "AudLock"
  | "VidTrack"
  | "CompCollapse"
  | "TextDeformed"
  | "UnsupportedFormat"
  | "LayerLocked"
  | "NameError"
  | "FontError"
  | "UnknownError";
export type IErrors = {
  [key in problemTypes]: string[];
};
export type WarningLayers = WarningLayer[];
export interface WarningLayer {
  layerName: string;
  warningType: WarningErrors;
}
export interface IFileSizes {
  name: string;
  sizeInKb: number;
}
export interface IProblems {
  problematicLayers: IErrors;
  fileSizes: IFileSizes[];
  warningLayers: WarningLayers;
}

export async function findProblemsBeforeRender() {
  const compId =
    rootStore.compositionStore.compositionCurrentlyRendering.id || 0;
  const res = await runEvalScript(
    `$._blingsio.dataManager.findProblemsBeforeRender(${compId})`
  );
  return res as IProblems;
}
export enum LayersErrors {
  Wav = "Wav",
  AudOffset = "AudOffset",
  AudLock = "AudLock",
  VidTrack = "VidTrack",
  CompCollapse = "CompCollapse",
  TextDeformed = "TextDeformed",
  UnsupportedFormat = "UnsupportedFormat",
  LayerLocked = "LayerLocked",
  NameError = "NameError",
  UnknownError = "UnknownError",
  FontError = "FontError",
}
export enum WarningErrors {
  videoOrder = "videoOrder",
}
export type HeaderTitles = Record<WarningErrors, string>;

export const HEADER_TITLES: HeaderTitles = {
  "videoOrder": "Video Layer Order",
};
